const formatSubpremise = (subpremise) => {
  const charCheck = /^[a-zA-z]/
  const startsWithLetter = charCheck.test(subpremise)
  return startsWithLetter ? `${subpremise}` : `#${subpremise}`
}
export default formatSubpremise
